export var Crypto;
(function (Crypto) {
    Crypto["GETRESPONSE"] = "getresponse";
})(Crypto || (Crypto = {}));
export const getBrandName = (payload) => {
    const { language, crypto } = payload;
    if (!crypto || crypto === Crypto.GETRESPONSE) {
        return `GetResponse[${language}]`;
    }
    return crypto;
};
export const getLiveChatParams = (payload) => {
    var _a, _b;
    const brandName = getBrandName({
        language: payload.language,
        crypto: (_a = payload.account) === null || _a === void 0 ? void 0 : _a.crypto,
    });
    const params = {};
    params['brand'] = brandName;
    params['original_user_group'] = payload.account === undefined ? 'visitor' : 'customer';
    params['live-chat-type'] = payload.buttonVariant ? payload.buttonVariant : 'bookmark';
    if (payload.account) {
        params['gr_login'] = payload.account.email;
        params['email'] = payload.account.email;
        params['name'] = payload.account.firstName;
        params['surname'] = payload.account.lastName;
        params['is_collaborator'] = payload.account.isCollaborator.toString();
        params['is_free_account'] = payload.account.isFree.toString();
        const isExpiredFree = payload.account.isFree && (payload.account.daysToExpiration || 1) <= 0;
        params['is_expired_free'] = isExpiredFree.toString();
        params['user_id'] = payload.account.userId.toString();
        params['account_type'] = (_b = payload.account.maxOfferSystem) !== null && _b !== void 0 ? _b : 'null';
        params['is_subaccount'] = (!payload.account.isOwner).toString();
        if (payload.account.collaboratorOwnerEmail !== undefined) {
            params['collaborator_owner_email'] = payload.account.collaboratorOwnerEmail;
        }
    }
    return params;
};
